// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:16 */
import { BaseData, ESexo, BaseDataDisplay, DataEndereco, EStatusPedidoSite, EArredondPrc, EFilterBool, EGenero, EFaixaEtaria, ETipoFrete } from './maf.vo';
import { ArrayList } from 'maf-web';

export class DataUrlParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataUrlParametrosAPP";
  itens: string[] = [];
  codEmpVendedor: number = 0;
  codVendedor: number = 0;
  codVitrine: number = 0;
  codEmpresaVenda: number = 0;
}


export class DataResultEmiteCartaoPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmiteCartaoPedido";
  nomeCartao: string = "";
  numeroCartao: string = "";
  codSeguranca: string = "";
  codMaclePagto: number = 0;
  link3DS: string = "";
  bandeira: string = "";
  mesValidade: number = 0;
  anoValidade: number = 0;
  qtdParcelas: number = 0;
  cnpjTitularCartao: string = "";
  analiseManualAntifraude: boolean = false;
}


export class DataCepAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCepAPP";
  cidade: string = "";
  codCEP: number = 0;
  codUF: string = "";
  bairro: string = "";
  logradouro: string = "";
}


export class DataPedidoEntregaLimiteEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaLimiteEnvioML";
  date: string = "";
}


export class LVDataTamanho extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTamanho";
  ordem: number = 0;
  EAN: string = "";
  codTamanho: number = 0;
  descTamanho: string = "";
  qtdEstoque: number = 0;
}


export class PKVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendaAPP";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaAPP {
    return new PKVendaAPP(this.codVenda);
  }

  public equals(arg: PKVendaAPP): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class PKClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKClienteAPP";
  codEmpresaCliente: number = 0;
  codCliente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
  }

  public getPK(): PKClienteAPP {
    return new PKClienteAPP(this.codEmpresaCliente, this.codCliente);
  }

  public equals(arg: PKClienteAPP): boolean {
    return arg 
        && (arg.codEmpresaCliente === this.codEmpresaCliente)
        && (arg.codCliente === this.codCliente)
    ;
  }
}


export class PKDependenteAPP extends PKClienteAPP {
  readonly jclass: string = "com.macle.app.vo.PKDependenteAPP";
  codDependente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number, codDependente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): PKDependenteAPP {
    return new PKDependenteAPP(this.codEmpresaCliente, this.codCliente, this.codDependente);
  }

  public equals(arg: PKDependenteAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codDependente === this.codDependente)
    ;
  }
}


export class DataVendaClienteAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaClienteAPP";
  cnpj: string = "";
  email: string = "";
  nome: string = "";
  sexo: ESexo = ESexo.NONE;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  telefone: string = "";
  dataNascimento: string = "";
  dadosResumido: boolean = false;
  inscEstadual: string = "";
}


export enum EStatusPedido {
  NONE = 0,
  PRECONFPAGTO = 7,
  CONFERENCIAPAGTO = 1,
  EMANALISE = 10,
  APROVADO = 6,
  REPROVADO = 8,
  EXPEDICAO = 2,
  EMBARQUE = 3,
  ENTREGUE = 4,
  CANCELADO = 5,
  DEVOLUCAO = 9,
  CONTESTADO = 11,
  NAOFINALIZADO = 12,
}

export namespace EStatusPedido {
  export function toDisplay(arg: EStatusPedido): string {
    switch (arg) {
      case 0: return "";
      case 7: return "";
      case 1: return "Confirma&amp;ccedil;&amp;atilde;o de pagamento";
      case 10: return "Pedido em an&amp;aacute;lise";
      case 6: return "Pedido aprovado";
      case 8: return "Pedido reprovado";
      case 2: return "Preparado para envio";
      case 3: return "Pedido em transporte";
      case 4: return "Pedido entregue";
      case 5: return "Pedido cancelado";
      case 9: return "Pedido devolvido";
      case 11: return "Contestado";
      case 12: return "Pedido nao Finalizado";
      default: return "";
    }
  }

  export function enums(): EStatusPedido[] {
    return [EStatusPedido.NONE,EStatusPedido.PRECONFPAGTO,EStatusPedido.CONFERENCIAPAGTO,EStatusPedido.EMANALISE,EStatusPedido.APROVADO,EStatusPedido.REPROVADO,EStatusPedido.EXPEDICAO,EStatusPedido.EMBARQUE,EStatusPedido.ENTREGUE,EStatusPedido.CANCELADO,EStatusPedido.DEVOLUCAO,EStatusPedido.CONTESTADO,EStatusPedido.NAOFINALIZADO];
  }
}


export class PKPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVit";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): PKPedidoVit {
    return new PKPedidoVit(this.codPedido);
  }

  public equals(arg: PKPedidoVit): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class DataPedidoAntFraudeVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoAntFraudeVit";
  ip: string = "";
  koinSessionID: string = "";
}


export class DataPedidoPaginacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPaginacaoML";
  offset: number = 0;
  limit: number = 0;
  total: number = 0;
}


export class PKItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemVit";
  codItemVit: number = 0;

  constructor()
  constructor(codItemVit: number)
  constructor(codItemVit?: number) {
    super();
    this.codItemVit = codItemVit || 0;
  }

  public getPK(): PKItemVit {
    return new PKItemVit(this.codItemVit);
  }

  public equals(arg: PKItemVit): boolean {
    return arg 
        && (arg.codItemVit === this.codItemVit)
    ;
  }
}


export class PKTamanhoItemVit extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKTamanhoItemVit";
  codTamanho: number = 0;

  constructor()
  constructor(codItemVit: number, codTamanho: number)
  constructor(codItemVit?: number, codTamanho?: number) {
    super();
    this.codItemVit = codItemVit || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemVit {
    return new PKTamanhoItemVit(this.codItemVit, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemVit): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class PKItemControleVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemControleVit";
  codItemControle: number = 0;
  codEmpresaControle: number = 0;

  constructor()
  constructor(codEmpresaControle: number, codItemControle: number)
  constructor(codEmpresaControle?: number, codItemControle?: number) {
    super();
    this.codEmpresaControle = codEmpresaControle || 0;
    this.codItemControle = codItemControle || 0;
  }

  public getPK(): PKItemControleVit {
    return new PKItemControleVit(this.codEmpresaControle, this.codItemControle);
  }

  public equals(arg: PKItemControleVit): boolean {
    return arg 
        && (arg.codItemControle === this.codItemControle)
        && (arg.codEmpresaControle === this.codEmpresaControle)
    ;
  }
}


export class DataVendaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVit";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  descricaoTamanho: string = "";
  qtd: number = 0;
  descricao: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  gtin: string = "";
  imgItemURL: string = "";
  itemControle: PKItemControleVit = new PKItemControleVit();
  descricaoMarca: string = "";
  descricaoCor: string = "";
  imgPequenoURL: string = "";
  googleCategory: string = "";
  codCupomDesconto: number = 0;

  constructor()
  constructor(item: PKTamanhoItemVit, gtin: string, descricaoTamanho: string, itemControle: PKItemControleVit, descricao: string, googleCategory: string, descricaoCor: string, descricaoMarca: string, imgItemURL: string, qtd: number, precoUnitario: number, desconto: number, precoCongelado: boolean)
  constructor(item?: PKTamanhoItemVit, gtin?: string, descricaoTamanho?: string, itemControle?: PKItemControleVit, descricao?: string, googleCategory?: string, descricaoCor?: string, descricaoMarca?: string, imgItemURL?: string, qtd?: number, precoUnitario?: number, desconto?: number, precoCongelado?: boolean) {
    super();
    this.item = item ||  new PKTamanhoItemVit();
    this.gtin = gtin || "";
    this.descricaoTamanho = descricaoTamanho || "";
    this.itemControle = itemControle ||  new PKItemControleVit();
    this.descricao = descricao || "";
    this.googleCategory = googleCategory || "";
    this.descricaoCor = descricaoCor || "";
    this.descricaoMarca = descricaoMarca || "";
    this.imgItemURL = imgItemURL || "";
    this.qtd = qtd || 0;
    this.precoUnitario = precoUnitario || 0;
    this.desconto = desconto || 0;
    this.precoCongelado = precoCongelado || false;
  }

  public getPK(): DataVendaItemVit {
    return new DataVendaItemVit(this.item, this.gtin, this.descricaoTamanho, this.itemControle, this.descricao, this.googleCategory, this.descricaoCor, this.descricaoMarca, this.imgItemURL, this.qtd, this.precoUnitario, this.desconto, this.precoCongelado);
  }

  public equals(arg: DataVendaItemVit): boolean {
    return arg 
        && (arg.item === this.item)
        && (arg.descricaoTamanho === this.descricaoTamanho)
        && (arg.qtd === this.qtd)
        && (arg.descricao === this.descricao)
        && (arg.desconto === this.desconto)
        && (arg.precoUnitario === this.precoUnitario)
        && (arg.precoCongelado === this.precoCongelado)
        && (arg.gtin === this.gtin)
        && (arg.imgItemURL === this.imgItemURL)
        && (arg.itemControle === this.itemControle)
        && (arg.descricaoMarca === this.descricaoMarca)
        && (arg.descricaoCor === this.descricaoCor)
        && (arg.imgPequenoURL === this.imgPequenoURL)
        && (arg.googleCategory === this.googleCategory)
        && (arg.codCupomDesconto === this.codCupomDesconto)
    ;
  }
}


export class DataPedidoMediadorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoMediadorML";
  id: number = 0;
}


export class DataPedidoClienteVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteVit";
  cnpj: string = "";
  email: string = "";
  nome: string = "";
  sexo: ESexo = ESexo.NONE;
  senha: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  telefone: string = "";
  dataNascimento: string = "";
  inscEstadual: string = "";
  codClienteVit: number = 0;
}


export class DataResultEmitePixPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmitePixPedido";
  valor: number = 0;
  dataHoraValidade: string = "";
  codMaclePagto: number = 0;
  pixCode: string = "";
  qrCodePix: string = "";
}


export enum EFormaPagamentoAPP {
  NONE = 0,
  BOLETO = 1,
  CARTAO = 2,
  CREDIARIO = 3,
  CONDICIONAL = 4,
  PIX = 5,
  MARKETPLACE = 6,
}

export namespace EFormaPagamentoAPP {
  export function toDisplay(arg: EFormaPagamentoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Boleto";
      case 2: return "Cart&atilde;o";
      case 3: return "Credi&aacute;rio";
      case 4: return "Condicional";
      case 5: return "PIX";
      case 6: return "Marketplace";
      default: return "";
    }
  }

  export function enums(): EFormaPagamentoAPP[] {
    return [EFormaPagamentoAPP.NONE,EFormaPagamentoAPP.BOLETO,EFormaPagamentoAPP.CARTAO,EFormaPagamentoAPP.CREDIARIO,EFormaPagamentoAPP.CONDICIONAL,EFormaPagamentoAPP.PIX,EFormaPagamentoAPP.MARKETPLACE];
  }
}


export class PKCondVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKCondVendaAPP";
  codEmpresaCondVenda: number = 0;
  codCondVenda: number = 0;

  constructor()
  constructor(codEmpresaCondVenda: number, codCondVenda: number)
  constructor(codEmpresaCondVenda?: number, codCondVenda?: number) {
    super();
    this.codEmpresaCondVenda = codEmpresaCondVenda || 0;
    this.codCondVenda = codCondVenda || 0;
  }

  public getPK(): PKCondVendaAPP {
    return new PKCondVendaAPP(this.codEmpresaCondVenda, this.codCondVenda);
  }

  public equals(arg: PKCondVendaAPP): boolean {
    return arg 
        && (arg.codEmpresaCondVenda === this.codEmpresaCondVenda)
        && (arg.codCondVenda === this.codCondVenda)
    ;
  }
}


export class DataPedidoFormaPagamentoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoFormaPagamentoVit";
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
  codMaclePagto: number = 0;
}


export class PKClienteMacleVitPub extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKClienteMacleVitPub";
  codClienteMacle: number = 0;
}


export class PKPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codPedido: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codPedido?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codPedido = codPedido || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKPedidoVitPub {
    return new PKPedidoVitPub(this.codPedido, this.clienteMacle);
  }

  public equals(arg: PKPedidoVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export enum ETipoFreteAPP {
  NONE = 0,
  SEDEX = 1,
  PAC = 2,
  ENVIO_FLEX_ML = 3,
}

export namespace ETipoFreteAPP {
  export function toDisplay(arg: ETipoFreteAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Sedex";
      case 2: return "PAC";
      case 3: return "Envio Flex";
      default: return "";
    }
  }

  export function enums(): ETipoFreteAPP[] {
    return [ETipoFreteAPP.NONE,ETipoFreteAPP.SEDEX,ETipoFreteAPP.PAC,ETipoFreteAPP.ENVIO_FLEX_ML];
  }
}


export class DataFreteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteAPP";
  valorFrete: number = 0;
  indisponivel: boolean = false;
  prazoEntrega: string = "";
  tipoFrete: ETipoFreteAPP = ETipoFreteAPP.NONE;
}


export class DataEntregaDistanciaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaDistanciaAPP";
  duracaoViagemSegundos: number = 0;
  destino: string = "";
  origem: string = "";
  distanciaKM: number = 0;
}


export class DataPedidoEntregaVitPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVitPub";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  retiradaLoja: boolean = false;
  taxaEntrega: number = 0;
}


export class PKVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendedorAPP";
  codEmpVendedor: number = 0;
  codVendedor: number = 0;

  constructor()
  constructor(codEmpVendedor: number, codVendedor: number)
  constructor(codEmpVendedor?: number, codVendedor?: number) {
    super();
    this.codEmpVendedor = codEmpVendedor || 0;
    this.codVendedor = codVendedor || 0;
  }

  public getPK(): PKVendedorAPP {
    return new PKVendedorAPP(this.codEmpVendedor, this.codVendedor);
  }

  public equals(arg: PKVendedorAPP): boolean {
    return arg 
        && (arg.codEmpVendedor === this.codEmpVendedor)
        && (arg.codVendedor === this.codVendedor)
    ;
  }
}


export class DataPedidoEnderecoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEnderecoVit";
  endereco: DataEndereco = new DataEndereco();
}


export class PKItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKItemAPP";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number)
  constructor(codEmpItem?: number, codItem?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): PKItemAPP {
    return new PKItemAPP(this.codEmpItem, this.codItem);
  }

  public equals(arg: PKItemAPP): boolean {
    return arg 
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class PKTamanhoItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.PKTamanhoItemAPP";
  codTamanho: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, codTamanho: number)
  constructor(codEmpItem?: number, codItem?: number, codTamanho?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemAPP {
    return new PKTamanhoItemAPP(this.codEmpItem, this.codItem, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class PKItemLojaVitPub extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemLojaVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codItemVit: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codItemVit?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codItemVit = codItemVit || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKItemLojaVitPub {
    return new PKItemLojaVitPub(this.codItemVit, this.clienteMacle);
  }

  public equals(arg: PKItemLojaVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class DataPedidoItemVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVitPub";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  qtd: number = 0;
  descricao: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
}


export class DataPedidoLojaPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoLojaPub";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  horaUltimoUpdate: string = "";
  dataUltimoUpdate: string = "";
  nroetiquetasigep: string = "";
  dataCancelamento: string = "";
}


export class DataPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVitPub";
  data: string = "";
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  hora: string = "";
  valor: number = 0;
  enviadoSistema: boolean = false;
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  listEntrega: ArrayList<DataPedidoEntregaVitPub> = new ArrayList<DataPedidoEntregaVitPub>(DataPedidoEntregaVitPub);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  listItem: ArrayList<DataPedidoItemVitPub> = new ArrayList<DataPedidoItemVitPub>(DataPedidoItemVitPub);
  desconto: number = 0;
  acrescimo: number = 0;
  listPedidoLoja: ArrayList<DataPedidoLojaPub> = new ArrayList<DataPedidoLojaPub>(DataPedidoLojaPub);
  codEmpresaPedido: number = 0;
}


export class PKZoopTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKZoopTransacaoAPP";
  codZoopTransacao: number = 0;

  constructor()
  constructor(codZoopTransacao: number)
  constructor(codZoopTransacao?: number) {
    super();
    this.codZoopTransacao = codZoopTransacao || 0;
  }

  public getPK(): PKZoopTransacaoAPP {
    return new PKZoopTransacaoAPP(this.codZoopTransacao);
  }

  public equals(arg: PKZoopTransacaoAPP): boolean {
    return arg 
        && (arg.codZoopTransacao === this.codZoopTransacao)
    ;
  }
}


export class DataZoopTransacaoAPP extends PKZoopTransacaoAPP {
  readonly jclass: string = "com.macle.app.vo.DataZoopTransacaoAPP";
  data: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  idCobranca: string = "";
  idPedido: string = "";
  idTransacao: number = 0;
  jsonTransacao: string = "";
}


export class DataPedidoClienteDocumentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoML";
  value: string = "";
  id: string = "";
}


export class DataEnderecoAuxML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoAuxML";
  name: string = "";
  id: string = "";
}


export class DataEnderecoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoML";
  state: DataEnderecoAuxML = new DataEnderecoAuxML();
  country: DataEnderecoAuxML = new DataEnderecoAuxML();
  comment: string = "";
  city: DataEnderecoAuxML = new DataEnderecoAuxML();
  street_name: string = "";
  street_number: string = "";
  zip_code: string = "";
  neighborhood: DataEnderecoAuxML = new DataEnderecoAuxML();
  receiver_name: string = "";
}


export class DataPedidoClienteDocumentoAdicionalML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoAdicionalML";
  value: string = "";
  type: string = "";
}


export class DataPedidoClienteReceiverML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteReceiverML";
  name: string = "";
  id: number = 0;
  document: DataPedidoClienteDocumentoML = new DataPedidoClienteDocumentoML();
  billing_address: DataEnderecoML = new DataEnderecoML();
  city_ibge: string = "";
  additional_documents: ArrayList<DataPedidoClienteDocumentoAdicionalML> = new ArrayList<DataPedidoClienteDocumentoAdicionalML>(DataPedidoClienteDocumentoAdicionalML);
}


export class DataPedidoClienteML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteML";
  receiver: DataPedidoClienteReceiverML = new DataPedidoClienteReceiverML();
}


export class PKParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKParcelaAPP";
  codEmpresaParcela: number = 0;
  codParcela: number = 0;

  constructor()
  constructor(codEmpresaParcela: number, codParcela: number)
  constructor(codEmpresaParcela?: number, codParcela?: number) {
    super();
    this.codEmpresaParcela = codEmpresaParcela || 0;
    this.codParcela = codParcela || 0;
  }

  public getPK(): PKParcelaAPP {
    return new PKParcelaAPP(this.codEmpresaParcela, this.codParcela);
  }

  public equals(arg: PKParcelaAPP): boolean {
    return arg 
        && (arg.codEmpresaParcela === this.codEmpresaParcela)
        && (arg.codParcela === this.codParcela)
    ;
  }
}


export class DataCanSelectParcelaApp extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCanSelectParcelaApp";
  parcela: PKParcelaAPP = new PKParcelaAPP();
  marcadas: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class DataEntregaLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaLojaVitrinePubAPP";
  distanciaKM: number = 0;
  codClienteMacle: number = 0;
  nomeLoja: string = "";
  distanciaEntregaGratisCompraAPP: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
}


export class DataResultFinalizaPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultFinalizaPedido";
  codPedido: number = 0;
  codMaclePagto: number = 0;
  link3DS: string = "";
}


export class FilterLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterLiquidacaoAPP";
}


export class PKContaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKContaAPP";
  codEmpresa: number = 0;
  codConta: number = 0;

  constructor()
  constructor(codEmpresa: number, codConta: number)
  constructor(codEmpresa?: number, codConta?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codConta = codConta || 0;
  }

  public getPK(): PKContaAPP {
    return new PKContaAPP(this.codEmpresa, this.codConta);
  }

  public equals(arg: PKContaAPP): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codConta === this.codConta)
    ;
  }
}


export class DataSendLiquidaParcelaZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaZoopAPP";
  conta: PKContaAPP = new PKContaAPP();
  dataPagamento: string = "";
  codEmpresa: number = 0;
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataEmissaoBoleto: string = "";
  transactionID: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  idTransacaoPIX: string = "";
  horaPagamento: string = "";
  valorPago: number = 0;
}


export enum EFormaPagto {
  NONE = 0,
  VISA = 1,
  MASTERCAR = 2,
  DINNERS = 3,
  AMERICANEXPRESS = 4,
  HIPERCARD = 5,
  BANCO_BRADESCO = 6,
  BANCO_BRASIL = 7,
  BANCO_ITAU = 8,
  BOLETO = 9,
  AMERICANEXPRESS_PAGSEGURO = 10,
  HIPERCARD_PAGSEGURO = 11,
  ITAU_PAGSEGURO = 12,
  BRADESCO_PAGSEGURO = 13,
  UNIBANCO_PAGSEGURO = 14,
  BANCOREAL_PAGSEGURO = 15,
  AURA_PAGSEGURO = 16,
  BANCOBRASIL_PAGSEGURO = 17,
  ELO = 18,
}

export namespace EFormaPagto {
  export function toDisplay(arg: EFormaPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Cart&amp;atilde;o Visa";
      case 2: return "Cart&amp;atilde;o MasterCard";
      case 3: return "Cart&amp;atilde;o Dinners";
      case 4: return "Cart&amp;atilde;o American Express";
      case 5: return "Cart&amp;atilde;o Hipercard";
      case 6: return "Banco Bradesco";
      case 7: return "Banco do Brasil";
      case 8: return "Banco Ita&amp;uacute;";
      case 9: return "Boleto";
      case 10: return "American Express - Pag Seguro";
      case 11: return "Hipercard - Pag Seguro";
      case 12: return "Ita&amp;uacute; - Pag Seguro";
      case 13: return "Bradesco - Pag Seguro";
      case 14: return "Unibanco - Pag Seguro";
      case 15: return "Banco Real - Pag Seguro";
      case 16: return "Aura - Pag Seguro";
      case 17: return "Banco do Brasil - Pag Seguro";
      case 18: return "Elo";
      default: return "";
    }
  }

  export function enums(): EFormaPagto[] {
    return [EFormaPagto.NONE,EFormaPagto.VISA,EFormaPagto.MASTERCAR,EFormaPagto.DINNERS,EFormaPagto.AMERICANEXPRESS,EFormaPagto.HIPERCARD,EFormaPagto.BANCO_BRADESCO,EFormaPagto.BANCO_BRASIL,EFormaPagto.BANCO_ITAU,EFormaPagto.BOLETO,EFormaPagto.AMERICANEXPRESS_PAGSEGURO,EFormaPagto.HIPERCARD_PAGSEGURO,EFormaPagto.ITAU_PAGSEGURO,EFormaPagto.BRADESCO_PAGSEGURO,EFormaPagto.UNIBANCO_PAGSEGURO,EFormaPagto.BANCOREAL_PAGSEGURO,EFormaPagto.AURA_PAGSEGURO,EFormaPagto.BANCOBRASIL_PAGSEGURO,EFormaPagto.ELO];
  }
}


export class LVPKPedido extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKPedido";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): LVPKPedido {
    return new LVPKPedido(this.codPedido);
  }

  public equals(arg: LVPKPedido): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class BaseTransp extends BaseData {
  readonly jclass: string = "com.macle.site.vo.BaseTransp";
  codLOG: number = 0;

  constructor()
  constructor(codLOG: number)
  constructor(codLOG?: number) {
    super();
    this.codLOG = codLOG || 0;
  }

  public getPK(): BaseTransp {
    return new BaseTransp(this.codLOG);
  }

  public equals(arg: BaseTransp): boolean {
    return arg 
        && (arg.codLOG === this.codLOG)
    ;
  }
}


export class LVPKItem extends BaseTransp {
  readonly jclass: string = "com.macle.site.vo.LVPKItem";
  codItem: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codLOG: number, codEmpresa: number, codItem: number)
  constructor(codLOG?: number, codEmpresa?: number, codItem?: number) {
    super();
    this.codLOG = codLOG || 0;
    this.codEmpresa = codEmpresa || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): LVPKItem {
    return new LVPKItem(this.codLOG, this.codEmpresa, this.codItem);
  }

  public equals(arg: LVPKItem): boolean {
    return arg && super.equals(arg)
        && (arg.codItem === this.codItem)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class LVCorItem extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVCorItem";
  codItem: LVPKItem = new LVPKItem();
  descCor: string = "";
  codCor: number = 0;
}


export class LVPedItem extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedItem";
  embalar: boolean = false;
  tamanho: LVDataTamanho = new LVDataTamanho();
  codItem: LVPKItem = new LVPKItem();
  qtd: number = 0;
  cor: LVCorItem = new LVCorItem();
  descricao: string = "";
  precoUnit: number = 0;
}


export enum ETipoConfirmacaoConsumidorSiteAPP {
  NONE = 0,
  SMS = 1,
  EMAIL = 2,
}

export namespace ETipoConfirmacaoConsumidorSiteAPP {
  export function toDisplay(arg: ETipoConfirmacaoConsumidorSiteAPP): string {
    switch (arg) {
      case 0: return "Nenhum";
      case 1: return "SMS";
      case 2: return "EMAIL";
      default: return "";
    }
  }

  export function enums(): ETipoConfirmacaoConsumidorSiteAPP[] {
    return [ETipoConfirmacaoConsumidorSiteAPP.NONE,ETipoConfirmacaoConsumidorSiteAPP.SMS,ETipoConfirmacaoConsumidorSiteAPP.EMAIL];
  }
}


export class ConsumidorSiteResponseGetConsumidorV0APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV0APP";
  chaveConfirmacao: number = 0;
  urlConsultaVendedor: string = "";
  clienteLocalizado: boolean = false;
  envioConfirmacao: string = "";
  token: string = "";
  vendedor: boolean = false;
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  tipoConfirmacao: ETipoConfirmacaoConsumidorSiteAPP = ETipoConfirmacaoConsumidorSiteAPP.NONE;
  confirmado: boolean = false;
}


export class ConsumidorSiteResponseGetConsumidorV1APP extends ConsumidorSiteResponseGetConsumidorV0APP {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV1APP";
  acessoAppPagtoParc: boolean = false;
}


export class PKVendaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKVendaVit";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaVit {
    return new PKVendaVit(this.codVenda);
  }

  public equals(arg: PKVendaVit): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class PKPedidoCupomDesconto extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoCupomDesconto";
  codCupomDesconto: number = 0;

  constructor()
  constructor(codPedido: number, codCupomDesconto: number)
  constructor(codPedido?: number, codCupomDesconto?: number) {
    super();
    this.codPedido = codPedido || 0;
    this.codCupomDesconto = codCupomDesconto || 0;
  }

  public getPK(): PKPedidoCupomDesconto {
    return new PKPedidoCupomDesconto(this.codPedido, this.codCupomDesconto);
  }

  public equals(arg: PKPedidoCupomDesconto): boolean {
    return arg && super.equals(arg)
        && (arg.codCupomDesconto === this.codCupomDesconto)
    ;
  }
}


export enum EModoCreditoClienteVit {
  NONE = 0,
  VALOR = 1,
  PERCENT_ITEM = 2,
  PERCENT_VENDA = 3,
}

export namespace EModoCreditoClienteVit {
  export function toDisplay(arg: EModoCreditoClienteVit): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Valor";
      case 2: return "Percentual item";
      case 3: return "Percentual venda";
      default: return "";
    }
  }

  export function enums(): EModoCreditoClienteVit[] {
    return [EModoCreditoClienteVit.NONE,EModoCreditoClienteVit.VALOR,EModoCreditoClienteVit.PERCENT_ITEM,EModoCreditoClienteVit.PERCENT_VENDA];
  }
}


export class DataPedidoCupomDesconto extends PKPedidoCupomDesconto {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCupomDesconto";
  ID: string = "";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  data: string = "";
  modo: EModoCreditoClienteVit = EModoCreditoClienteVit.NONE;
  valorCupom: number = 0;
  valorPedido: number = 0;
  creditoCliente: boolean = false;
}


export class DataVendaVit extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVit";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  codEmpresaVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  listItem: ArrayList<DataVendaItemVit> = new ArrayList<DataVendaItemVit>(DataVendaItemVit);
  desconto: number = 0;
  codVitrineVenda: number = 0;
  qtdItensVenda: number = 0;
  precoTotalVenda: number = 0;
  listCupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
}


export class ConsParcelaLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsParcelaLiquidacaoAPP";
  numeroTotalParcelas: number = 0;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  parcela: PKParcelaAPP = new PKParcelaAPP();
  saldo: number = 0;
  vencida: boolean = false;
  documentoOrigem: string = "";
  numeroParcela: number = 0;
  dataVencimento: string = "";
  dataEmissao: string = "";
}


export class PKLiquidacaoParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKLiquidacaoParcelaAPP";
  codLiquidacaoParcela: number = 0;

  constructor()
  constructor(codLiquidacaoParcela: number)
  constructor(codLiquidacaoParcela?: number) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
  }

  public getPK(): PKLiquidacaoParcelaAPP {
    return new PKLiquidacaoParcelaAPP(this.codLiquidacaoParcela);
  }

  public equals(arg: PKLiquidacaoParcelaAPP): boolean {
    return arg 
        && (arg.codLiquidacaoParcela === this.codLiquidacaoParcela)
    ;
  }
}


export enum EVersaoIntegracaoPagarmeAPP {
  NONE = 0,
  V2 = 1,
  V5 = 2,
  V6 = 3,
}

export namespace EVersaoIntegracaoPagarmeAPP {
  export function toDisplay(arg: EVersaoIntegracaoPagarmeAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagar.me V2";
      case 2: return "Pagar.me V5";
      case 3: return "Zoop";
      default: return "";
    }
  }

  export function enums(): EVersaoIntegracaoPagarmeAPP[] {
    return [EVersaoIntegracaoPagarmeAPP.NONE,EVersaoIntegracaoPagarmeAPP.V2,EVersaoIntegracaoPagarmeAPP.V5,EVersaoIntegracaoPagarmeAPP.V6];
  }
}


export enum EStatusLiquidacaoAPP {
  NONE = 0,
  PENDENTE = 1,
  LIQUIDADO = 2,
  EXPIRADA = 3,
}

export namespace EStatusLiquidacaoAPP {
  export function toDisplay(arg: EStatusLiquidacaoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pendente";
      case 2: return "Liquidado";
      case 3: return "Expirada";
      default: return "";
    }
  }

  export function enums(): EStatusLiquidacaoAPP[] {
    return [EStatusLiquidacaoAPP.NONE,EStatusLiquidacaoAPP.PENDENTE,EStatusLiquidacaoAPP.LIQUIDADO,EStatusLiquidacaoAPP.EXPIRADA];
  }
}


export class DataLiquidacaoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataLiquidacaoParcelaAPP";
  data: string = "";
  dataHoraValidadePIX: string = "";
  versaointegracao: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  ativo: boolean = false;
  valor: number = 0;
  status: EStatusLiquidacaoAPP = EStatusLiquidacaoAPP.NONE;
  conta: PKContaAPP = new PKContaAPP();
  codEmpresa: number = 0;
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  qrCodePIXBase64: string = "";
  idPedido: string = "";
  enviadoSistema: boolean = false;
  listParcela: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  transactionId: string = "";
  vencimento: string = "";
  lineBoleto: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  qrCodePIX: string = "";
}


export class DataDadosClienteEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataDadosClienteEmissaoBoletoAPP";
  email: string = "";
  nome: string = "";
  enderecoBairro: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  enderecoNumero: string = "";
  numeroDocumento: string = "";
  endereco: string = "";
  telefone: string = "";
}


export class DataConsultaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataConsultaParcelaAPP";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  listParcelas: ArrayList<ConsParcelaLiquidacaoAPP> = new ArrayList<ConsParcelaLiquidacaoAPP>(ConsParcelaLiquidacaoAPP);
  listBoletos: ArrayList<DataLiquidacaoParcelaAPP> = new ArrayList<DataLiquidacaoParcelaAPP>(DataLiquidacaoParcelaAPP);
  dadosCliente: DataDadosClienteEmissaoBoletoAPP = new DataDadosClienteEmissaoBoletoAPP();
}


export class DataContaAPP extends PKContaAPP {
  readonly jclass: string = "com.macle.app.vo.DataContaAPP";
  codLoja: number = 0;
  idSeller: string = "";
  descricao: string = "";
}


export enum EStatusPedidoML {
  NONE = 0,
  confirmed = 1,
  payment_required = 2,
  payment_in_process = 3,
  partially_paid = 4,
  paid = 5,
  partially_refunded = 6,
  pending_cancel = 7,
  cancelled = 8,
  invalid = 9,
}

export namespace EStatusPedidoML {
  export function toDisplay(arg: EStatusPedidoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Status inicial de uma order; ainda sem ter sido paga.";
      case 2: return "O pagamento da order deve ter sido confirmado para exibir as informa&ccedil;&otilde;es do usu&aacute;rio.";
      case 3: return "H&aacute; um pagamento relacionado à order, mais ainda n&atilde;o foi aprovado.";
      case 4: return "A order tem um pagamento associado creditado, por&eacute;m, insuficiente.";
      case 5: return "A order tem um pagamento associado aprovado.";
      case 6: return "A order tem devolu&ccedil;&otilde;es paciais de seus pagamentos.";
      case 7: return "Quando a order foi cancelada mas temos dificultdade para devolver o pagamento.";
      case 8: return "Por alguma raz&atilde;o, a order n&atilde;o foi completada.";
      case 9: return "A order foi invalidada por vir de um comprador malicioso.";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoML[] {
    return [EStatusPedidoML.NONE,EStatusPedidoML.confirmed,EStatusPedidoML.payment_required,EStatusPedidoML.payment_in_process,EStatusPedidoML.partially_paid,EStatusPedidoML.paid,EStatusPedidoML.partially_refunded,EStatusPedidoML.pending_cancel,EStatusPedidoML.cancelled,EStatusPedidoML.invalid];
  }
}


export class DataVendaVitrinePublicaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaVitrinePublicaAPP";
  clienteMacle: ArrayList<PKClienteMacleVitPub> = new ArrayList<PKClienteMacleVitPub>(PKClienteMacleVitPub);
}


export class DataFrenetShippingItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingItemVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  SKU: string = "";
  quantity: number = 0;
  category: string = "";
}


export class DataFrenetShippingVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingVit";
  shippingServiceCode: string = "";
  sellerCEP: string = "";
  recipientCEP: string = "";
  shippingItemArray: ArrayList<DataFrenetShippingItemVit> = new ArrayList<DataFrenetShippingItemVit>(DataFrenetShippingItemVit);
  shipmentInvoiceValue: number = 0;
  recipientCountry: string = "";
}


export class DataFrenetEnderecoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEnderecoVit";
  country: string = "";
  city: string = "";
  street: string = "";
  zipCode: string = "";
  addressQuarter: string = "";
  postalBoxCode: string = "";
  enderecoCompleto: boolean = false;
  addressNumber: string = "";
  addressState: string = "";
  addressComplement: string = "";
}


export class PKPagamentoPIXAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoPIXAPP";
  codPagamentoPIX: number = 0;

  constructor()
  constructor(codPagamentoPIX: number)
  constructor(codPagamentoPIX?: number) {
    super();
    this.codPagamentoPIX = codPagamentoPIX || 0;
  }

  public getPK(): PKPagamentoPIXAPP {
    return new PKPagamentoPIXAPP(this.codPagamentoPIX);
  }

  public equals(arg: PKPagamentoPIXAPP): boolean {
    return arg 
        && (arg.codPagamentoPIX === this.codPagamentoPIX)
    ;
  }
}


export class DataPagamentoPIXAPP extends PKPagamentoPIXAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoPIXAPP";
  liquidacaoParcela: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  dataHoraValidoAte: string = "";
  venda: PKVendaAPP = new PKVendaAPP();
  pago: boolean = false;
  conta: PKContaAPP = new PKContaAPP();
  idCobranca: string = "";
  codEmpresa: number = 0;
  idPedido: string = "";
  transactionId: string = "";
}


export class PKDocVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKDocVendaAPP";
  numero: number = 0;
  serie: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codEmpresa: number, serie: number, numero: number)
  constructor(codEmpresa?: number, serie?: number, numero?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.serie = serie || 0;
    this.numero = numero || 0;
  }

  public getPK(): PKDocVendaAPP {
    return new PKDocVendaAPP(this.codEmpresa, this.serie, this.numero);
  }

  public equals(arg: PKDocVendaAPP): boolean {
    return arg 
        && (arg.numero === this.numero)
        && (arg.serie === this.serie)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class DataShareItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataShareItemAPP";
  imgNome: string = "";
  descItem: string = "";
  imgBase64: string = "";
}


export class ConsCondVendaAPP extends PKCondVendaAPP {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAPP";
  pctDesc: number = 0;
  descricao: string = "";
  numParcelas: number = 0;
  diaVencto: number = 0;
  dataPrimParc: string = "";
  pctEntrada: number = 0;
  pctAcres: number = 0;
  diaPrimeiraParc: number = 0;
  trintaDiasDireto: boolean = false;
  arredond: EArredondPrc = EArredondPrc.NONE;
  forceVlrParc: number = 0;
  diaEntreParc: number = 0;
}


export class ConsCondVendaAuxAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAuxAPP";
  listCondVenda: ArrayList<ConsCondVendaAPP> = new ArrayList<ConsCondVendaAPP>(ConsCondVendaAPP);
}


export class ConsImgItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsImgItemAPP";
  imagens: string[] = [];
}


export class DataSendLiquidaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaAPP";
  dataPagamento: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataEmissaoBoleto: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  idTransacao: number = 0;
  valorPago: number = 0;
  idPagamento: number = 0;
}


export class LVPedStatsSO extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsSO";
  SO: string = "";
}


export class PKItemHashtagVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemHashtagVit";
  codHashtag: number = 0;

  constructor()
  constructor(codHashtag: number)
  constructor(codHashtag?: number) {
    super();
    this.codHashtag = codHashtag || 0;
  }

  public getPK(): PKItemHashtagVit {
    return new PKItemHashtagVit(this.codHashtag);
  }

  public equals(arg: PKItemHashtagVit): boolean {
    return arg 
        && (arg.codHashtag === this.codHashtag)
    ;
  }
}


export class DataItemHashTagVit extends PKItemHashtagVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataItemHashTagVit";
  hashtag: string = "";
}


export class DataPedidoPagamentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPagamentoML";
  id: number = 0;
  status: any;
  reason: string = "";
  installments: number = 0;
  payer_id: number = 0;
  order_id: number = 0;
  transaction_amount: number = 0;
  total_paid_amount: number = 0;
  payment_method_id: string = "";
  date_created: string = "";
  transaction_amount_refunded: number = 0;
}


export class DataPedidoItemVariacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVariacaoML";
  name: string = "";
  id: string = "";
  value_id: string = "";
  value_name: string = "";
}


export class DataSendStatusPedido extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendStatusPedido";
  venda: PKPedidoVit = new PKPedidoVit();
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
}


export class DataFrenetEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEtiquetaErroVit";
  message: string = "";
  code: number = 0;
}


export class DataFrenetPedidoEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaErroVit";
  message: string = "";
  details: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
}


export class DataPedidoShippingML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoShippingML";
  id: number = 0;
}


export class DataResultEmiteBoletoZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteBoletoZoopAPP";
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  vencimentoBoleto: string = "";
  valorBoletoSemTaxa: number = 0;
  pkTransacao: PKZoopTransacaoAPP = new PKZoopTransacaoAPP();
  valorBoleto: number = 0;
}


export enum EClasseItemSite {
  NONE = "''",
  NORMAL = "'N'",
  PROMOCAO = "'P'",
  LANCAMENTO = "'L'",
  DESTAQUE = "'D'",
  TODOS_SITE = "'TODOS_SITE'",
  FORA_SITE = "'FORA_SITE'",
}

export namespace EClasseItemSite {
  export function toDisplay(arg: EClasseItemSite): string {
    switch (arg) {
      case "''": return "";
      case "'N'": return "Normal";
      case "'P'": return "Promo&ccedil;&atilde;o";
      case "'L'": return "Lan&ccedil;amento";
      case "'D'": return "Destaque";
      case "'TODOS_SITE'": return "Todos do site";
      case "'FORA_SITE'": return "Fora do site";
      default: return "";
    }
  }

  export function enums(): EClasseItemSite[] {
    return [EClasseItemSite.NONE,EClasseItemSite.NORMAL,EClasseItemSite.PROMOCAO,EClasseItemSite.LANCAMENTO,EClasseItemSite.DESTAQUE,EClasseItemSite.TODOS_SITE,EClasseItemSite.FORA_SITE];
  }
}


export class DataPedidoEntregaOpcaoEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaOpcaoEnvioML";
  estimated_delivery_limit: DataPedidoEntregaLimiteEnvioML = new DataPedidoEntregaLimiteEnvioML();
}


export class DataDocVendaItemAPP extends PKTamanhoItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaItemAPP";
  descricaoTamanho: string = "";
  imagem: string = "";
  qtd: number = 0;
  descricao: string = "";
}


export class DataDocVendaAPP extends PKDocVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaAPP";
  itens: ArrayList<DataDocVendaItemAPP> = new ArrayList<DataDocVendaItemAPP>(DataDocVendaItemAPP);
  hora: string = "";
  dataEmissao: string = "";
}


export class DataParametrosVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataParametrosVit";
  pixelID: string = "";
  gtmID: string = "";
  habilitaGTM: boolean = false;
  googleAnalytics: string = "";
  habilitaPixel: boolean = false;
  googleVerificacao: string = "";
  listarTodasLojasRetirada: boolean = false;

  constructor()
  constructor(habilitaPixel: boolean, pixelID: string, habilitaGTM: boolean, gtmID: string, googleVerificacao: string, googleAnalytics: string, listarTodasLojasRetirada: boolean)
  constructor(habilitaPixel?: boolean, pixelID?: string, habilitaGTM?: boolean, gtmID?: string, googleVerificacao?: string, googleAnalytics?: string, listarTodasLojasRetirada?: boolean) {
    super();
    this.habilitaPixel = habilitaPixel || false;
    this.pixelID = pixelID || "";
    this.habilitaGTM = habilitaGTM || false;
    this.gtmID = gtmID || "";
    this.googleVerificacao = googleVerificacao || "";
    this.googleAnalytics = googleAnalytics || "";
    this.listarTodasLojasRetirada = listarTodasLojasRetirada || false;
  }

  public getPK(): DataParametrosVit {
    return new DataParametrosVit(this.habilitaPixel, this.pixelID, this.habilitaGTM, this.gtmID, this.googleVerificacao, this.googleAnalytics, this.listarTodasLojasRetirada);
  }

  public equals(arg: DataParametrosVit): boolean {
    return arg 
        && (arg.pixelID === this.pixelID)
        && (arg.gtmID === this.gtmID)
        && (arg.habilitaGTM === this.habilitaGTM)
        && (arg.googleAnalytics === this.googleAnalytics)
        && (arg.habilitaPixel === this.habilitaPixel)
        && (arg.googleVerificacao === this.googleVerificacao)
        && (arg.listarTodasLojasRetirada === this.listarTodasLojasRetirada)
    ;
  }
}


export class DataPedidoCompradorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCompradorML";
  id: number = 0;
  nickname: string = "";
}


export class DataPedidoEntregaML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaML";
  logistic_type: string = "";
  base_cost: number = 0;
  receiver_id: number = 0;
  sender_id: number = 0;
  tracking_number: string = "";
  tracking_method: string = "";
  shipping_option: DataPedidoEntregaOpcaoEnvioML = new DataPedidoEntregaOpcaoEnvioML();
  receiver_address: DataEnderecoML = new DataEnderecoML();
}


export class DataPedidoItemDadosML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemDadosML";
  id: string = "";
  title: string = "";
  seller_sku: string = "";
  warranty: string = "";
  variation_id: number = 0;
  category_id: string = "";
  variation_attributes: ArrayList<DataPedidoItemVariacaoML> = new ArrayList<DataPedidoItemVariacaoML>(DataPedidoItemVariacaoML);
}


export class DataPedidoItemML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemML";
  item: DataPedidoItemDadosML = new DataPedidoItemDadosML();
  unit_price: number = 0;
  sale_fee: number = 0;
  full_unit_price: number = 0;
  quantity: number = 0;
  listing_type_id: string = "";
}


export class DataPedidoResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoResultML";
  id: number = 0;
  cliente: DataPedidoClienteML = new DataPedidoClienteML();
  status: any;
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  entrega: DataPedidoEntregaML = new DataPedidoEntregaML();
  pack_id: number = 0;
  seller: DataPedidoCompradorML = new DataPedidoCompradorML();
  expiration_date: string = "";
  date_closed: string = "";
  total_amount: number = 0;
  shipping: DataPedidoShippingML = new DataPedidoShippingML();
  order_items: ArrayList<DataPedidoItemML> = new ArrayList<DataPedidoItemML>(DataPedidoItemML);
  paid_amount: number = 0;
  payments: ArrayList<DataPedidoPagamentoML> = new ArrayList<DataPedidoPagamentoML>(DataPedidoPagamentoML);
  mediations: ArrayList<DataPedidoMediadorML> = new ArrayList<DataPedidoMediadorML>(DataPedidoMediadorML);
  date_last_updated: string = "";
  last_updated: string = "";
  date_created: string = "";
}


export class DataPedidoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoML";
  query: string = "";
  display: string = "";
  paging: DataPedidoPaginacaoML = new DataPedidoPaginacaoML();
  results: ArrayList<DataPedidoResultML> = new ArrayList<DataPedidoResultML>(DataPedidoResultML);
}


export class LVPedEndereco extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedEndereco";
  numero: string = "";
  cidade: string = "";
  CEP: number = 0;
  bairro: string = "";
  estado: string = "";
  descricaoEndereco: string = "";
  endereco: string = "";
  infReferencia: string = "";
  retirarLoja: boolean = false;
}


export class LVDataTransacaoCieloResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoCieloResult";
  codPedidoTransacao: number = 0;
  bandeiraTransacao: EFormaPagto = EFormaPagto.NONE;
  mensagemAutorisacao: string = "";
  produtoFormaPagto: string = "";
  parcelasFormaPagto: number = 0;
  statusAutorizacao: number = 0;
  statusTransacao: number = 0;
  codigoCaptura: number = 0;
  mensagemCaptura: string = "";
  panTransacao: string = "";
  tidTransacao: string = "";
  arpAutorisacao: string = "";
  nsuAutorisacao: string = "";
  dataTransacao: string = "";
  horaTransacao: string = "";
  lrAutorisacao: string = "";
  valorTransacao: number = 0;
}


export class LVDataTransacaoRedecardResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoRedecardResult";
  data: string = "";
  pedido: LVPKPedido = new LVPKPedido();
  descricaoRetorno: string = "";
  descricao: string = "";
  nsuAutorizacao: string = "";
  nroSeqUnico: string = "";
  codRetorno: number = 0;
  nroAutorizacao: number = 0;
  nroAutenticacao: string = "";
  codPaisEmissor: string = "";
  codConfirmacaoAutomatica: number = 0;
}


export enum ETipoPagto {
  NONE = 0,
  PAGSYS = 1,
  PAGSEGURO = 2,
  CIELO = 3,
  ITAU = 4,
  REDECARD = 5,
}

export namespace ETipoPagto {
  export function toDisplay(arg: ETipoPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagsys";
      case 2: return "Pag Seguro";
      case 3: return "Cielo";
      case 4: return "Itau";
      case 5: return "Redecard";
      default: return "";
    }
  }

  export function enums(): ETipoPagto[] {
    return [ETipoPagto.NONE,ETipoPagto.PAGSYS,ETipoPagto.PAGSEGURO,ETipoPagto.CIELO,ETipoPagto.ITAU,ETipoPagto.REDECARD];
  }
}


export class LVPedFrete extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFrete";
  CEP: number = 0;
  valorFrete: number = 0;
  prazoEntrega: string = "";
  tipoFrete: ETipoFrete = ETipoFrete.NONE;
  nroObjetoPac: string = "";
}


export class LVPedFormaPagto extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFormaPagto";
  nome: string = "";
  valMes: string = "";
  valAno: string = "";
  formaPagamento: EFormaPagto = EFormaPagto.NONE;
  nroParcelas: number = 0;
  codSeguranca: string = "";
  numCartao: string = "";
}


export class LVPedStatsBrowser extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsBrowser";
  browser: string = "";
  browserType: string = "";
  versaoBrowser: string = "";
}


export class LVPedStats extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStats";
  browser: LVPedStatsBrowser = new LVPedStatsBrowser();
  SO: LVPedStatsSO = new LVPedStatsSO();
  ipCliente: string = "";
}


export class LVPKClienteSite extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKClienteSite";
  codSite: number = 0;
  codCliente: number = 0;
  codDependente: number = 0;
  codEmpCli: number = 0;

  constructor()
  constructor(codSite: number, codEmpCli: number, codCliente: number, codDependente: number)
  constructor(codSite?: number, codEmpCli?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codSite = codSite || 0;
    this.codEmpCli = codEmpCli || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): LVPKClienteSite {
    return new LVPKClienteSite(this.codSite, this.codEmpCli, this.codCliente, this.codDependente);
  }

  public equals(arg: LVPKClienteSite): boolean {
    return arg 
        && (arg.codSite === this.codSite)
        && (arg.codCliente === this.codCliente)
        && (arg.codDependente === this.codDependente)
        && (arg.codEmpCli === this.codEmpCli)
    ;
  }
}


export class LVPKVendedor extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKVendedor";
  codEmpresa: number = 0;
  codFuncionario: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): LVPKVendedor {
    return new LVPKVendedor(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: LVPKVendedor): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codFuncionario === this.codFuncionario)
    ;
  }
}


export class LVDataVendedor extends LVPKVendedor {
  readonly jclass: string = "com.macle.site.vo.LVDataVendedor";
  nome: string = "";
  listPed: ArrayList<LVPKPedido> = new ArrayList<LVPKPedido>(LVPKPedido);
  nickName: string = "";
}


export class LVPedCliente extends LVPKClienteSite {
  readonly jclass: string = "com.macle.site.vo.LVPedCliente";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  senha: string = "";
  nomeCli: string = "";
  CPF: string = "";
  enderecoCobranca: LVPedEndereco = new LVPedEndereco();
  dataNascimento: string = "";
  telResidencial: string = "";
  vendedor: LVDataVendedor = new LVDataVendedor();
  enderecoEntrega: LVPedEndereco = new LVPedEndereco();
  telCelular: string = "";
}


export class LVPedido extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedido";
  data: string = "";
  hora: string = "";
  status: EStatusPedido = EStatusPedido.NONE;
  enviadoSistema: boolean = false;
  pedEnderecoComprador: LVPedEndereco = new LVPedEndereco();
  pedEnderecoEntrega: LVPedEndereco = new LVPedEndereco();
  pedTransacaoCielo: LVDataTransacaoCieloResult = new LVDataTransacaoCieloResult();
  pedTransacaoRedecard: LVDataTransacaoRedecardResult = new LVDataTransacaoRedecardResult();
  tipoPagto: ETipoPagto = ETipoPagto.NONE;
  pedFrete: LVPedFrete = new LVPedFrete();
  listPedItem: ArrayList<LVPedItem> = new ArrayList<LVPedItem>(LVPedItem);
  pedFormaPagto: LVPedFormaPagto = new LVPedFormaPagto();
  pedStats: LVPedStats = new LVPedStats();
  pedCliente: LVPedCliente = new LVPedCliente();
  vendedor: LVPKVendedor = new LVPKVendedor();
  requestPedido: number = 0;
  pedidoFinalizado: boolean = false;
}


export class DataFrenetCotacaoServicoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoVit";
  ownHand: boolean = false;
  declaredValue: boolean = false;
  receiptNotification: boolean = false;
}


export class DataFrenetCotacaoServicoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoResponseVit";
  error: boolean = false;
  services: DataFrenetCotacaoServicoVit = new DataFrenetCotacaoServicoVit();
  carrier: string = "";
  msg: string = "";
  shippingServiceCode: string = "";
  shippingServiceName: string = "";
  shippingPrice: number = 0;
  deliveryTime: number = 0;
  carrierCode: string = "";
  platformShippingPrice: number = 0;
  shippingCompetitorPrice: number = 0;
}


export class DataFrenetCotacaoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoResponseVit";
  sessionId: string = "";
  quotations: ArrayList<DataFrenetCotacaoServicoResponseVit> = new ArrayList<DataFrenetCotacaoServicoResponseVit>(DataFrenetCotacaoServicoResponseVit);
  shippingServiceCodeSelect: string = "";
}


export class DataVendaEntregaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEntregaAPP";
  frete: DataFreteAPP = new DataFreteAPP();
  codClienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();
  codEmpresaRetiradaLoja: number = 0;
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  retiradaLoja: boolean = false;
  taxaEntrega: number = 0;
}


export class ConsItemVitEstoque extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.ConsItemVitEstoque";
  qtd: number = 0;
  ordem: number = 0;
  codTamanho: number = 0;
  descricao: string = "";

  constructor()
  constructor(codTamanho: number, descricao: string, ordem: number, qtd: number)
  constructor(codTamanho?: number, descricao?: string, ordem?: number, qtd?: number) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.ordem = ordem || 0;
    this.qtd = qtd || 0;
  }

  public getPK(): ConsItemVitEstoque {
    return new ConsItemVitEstoque(this.codTamanho, this.descricao, this.ordem, this.qtd);
  }

  public equals(arg: ConsItemVitEstoque): boolean {
    return arg 
        && (arg.qtd === this.qtd)
        && (arg.ordem === this.ordem)
        && (arg.codTamanho === this.codTamanho)
        && (arg.descricao === this.descricao)
    ;
  }
}


export class DataFrenetPedidoEtiquetaItemResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemResponseVit";
  errors: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
  orderId: string = "";
  declarationUrl: string = "";
  validThrough: string = "";
  shipmentId: number = 0;
  labelUrl: string = "";
  shipmentStatus: number = 0;
  trackingUrl: string = "";
  receiptNotificationUrl: string = "";
}


export class DataPackIdOrdersResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdOrdersResultML";
  id: number = 0;
  static_tags: string[] = [];
}


export class DataPackIdResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdResultML";
  id: number = 0;
  status: string = "";
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  orders: ArrayList<DataPackIdOrdersResultML> = new ArrayList<DataPackIdOrdersResultML>(DataPackIdOrdersResultML);
  status_detail: string = "";
  shipment: DataPedidoShippingML = new DataPedidoShippingML();
  last_updated: string = "";
  date_created: string = "";
  trash_pack_id: number = 0;
  family_pack_id: number = 0;
}


export class DataFrenetPedidoEtiquetaVolumeVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVolumeVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  price: number = 0;
  volumeId: number = 0;
  declaredValue: number = 0;
}


export class DataFrenetPedidoEtiquetaClienteVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaClienteVit";
  name: string = "";
  address: DataFrenetEnderecoVit = new DataFrenetEnderecoVit();
  email: string = "";
  IE: string = "";
  phone: string = "";
  cellphone: string = "";
  document: string = "";
}


export class DataFrenetPedidoEtiquetaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  fragile: boolean = false;
  price: number = 0;
  orderId: string = "";
  sku: string = "";
  itemId: string = "";
  productType: string = "";
  productId: string = "";
  productOptions: string = "";
  quantity: number = 0;
  category: string = "";
  productName: string = "";
}


export class DataFrenetPedidoEtiquetaNotaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaNotaVit";
  value: number = 0;
  key: string = "";
  number: string = "";
  date: string = "";
  CFOP: string = "";
  series: string = "";
}


export class DataFrenetPedidoEtiquetaOrdemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaOrdemVit";
  value: number = 0;
  id: string = "";
  from: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  items: ArrayList<DataFrenetPedidoEtiquetaItemVit> = new ArrayList<DataFrenetPedidoEtiquetaItemVit>(DataFrenetPedidoEtiquetaItemVit);
  to: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  created: string = "";
  invoice: DataFrenetPedidoEtiquetaNotaVit = new DataFrenetPedidoEtiquetaNotaVit();
  useFrenetRegistration: boolean = false;
}


export class DataFrenetPedidoEtiquetaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVit";
  volumes: DataFrenetPedidoEtiquetaVolumeVit = new DataFrenetPedidoEtiquetaVolumeVit();
  order: DataFrenetPedidoEtiquetaOrdemVit = new DataFrenetPedidoEtiquetaOrdemVit();
  shipmentId: number = 0;
  shipmentStatus: number = 0;
  quotation: DataFrenetCotacaoServicoResponseVit = new DataFrenetCotacaoServicoResponseVit();
  branchCode: string = "";
  trackingNotificationUrl: string = "";
  statusNotificationUrl: string = "";
}


export class DataVendaEnderecoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEnderecoAPP";
  endereco: DataEndereco = new DataEndereco();
}


export class ConsLojaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojaAPP";
  cnpj: string = "";
  numero: string = "";
  cidade: string = "";
  CEP: number = 0;
  UF: string = "";
  bairro: string = "";
  logradouro: string = "";
  fantasia: string = "";
  codEmpresa: number = 0;
}


export class ConsVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsVendedorAPP";
  nome: string = "";
  codEmpVendedor: number = 0;
  whatsApp: number = 0;
  fotoBase64: string = "";
  codVendedor: number = 0;
  listEmpresa: number[] = [];
}


export class ConsLojasComVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojasComVendedorAPP";
  listLoja: ArrayList<ConsLojaAPP> = new ArrayList<ConsLojaAPP>(ConsLojaAPP);
  listVendedor: ArrayList<ConsVendedorAPP> = new ArrayList<ConsVendedorAPP>(ConsVendedorAPP);
}


export class DataVendaFormaPagamentoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaFormaPagamentoAPP";
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
  codMaclePagto: number = 0;
}


export class DataSendLiquidaParcelaPagarmeV5APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaPagarmeV5APP";
  dataPagamento: string = "";
  idCobranca: string = "";
  idPedido: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataEmissaoBoleto: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
}


export class DataShareAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataShareAPP";
  url: string = "";
  itens: ArrayList<DataShareItemAPP> = new ArrayList<DataShareItemAPP>(DataShareItemAPP);
}


export class FilterNCE extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterNCE";
  promo: boolean = false;
  nivel2: number = 0;
  nivel6: number = 0;
  nivel9: number = 0;
  nivel3: number = 0;
  nivel8: number = 0;
  nivel1: number = 0;
  nivel5: number = 0;
  nivel4: number = 0;
  nivel7: number = 0;
  refFornecedor: string = "";
  codTamanho: number = 0;
  exibeEstoqueApenasLoja: boolean = false;
  descricao: string = "";
  minFaixaPreco: number = 0;
  codMarca: number = 0;
  maxFaixaPreco: number = 0;
  exibeItemZerado: boolean = false;
  codEmpresaLogin: number = 0;
  public equals(arg: FilterNCE): boolean {
    return arg 
        && (arg.promo === this.promo)
        && (arg.nivel2 === this.nivel2)
        && (arg.nivel6 === this.nivel6)
        && (arg.nivel9 === this.nivel9)
        && (arg.nivel3 === this.nivel3)
        && (arg.nivel8 === this.nivel8)
        && (arg.nivel1 === this.nivel1)
        && (arg.nivel5 === this.nivel5)
        && (arg.nivel4 === this.nivel4)
        && (arg.nivel7 === this.nivel7)
        && (arg.refFornecedor === this.refFornecedor)
        && (arg.codTamanho === this.codTamanho)
        && (arg.exibeEstoqueApenasLoja === this.exibeEstoqueApenasLoja)
        && (arg.descricao === this.descricao)
        && (arg.minFaixaPreco === this.minFaixaPreco)
        && (arg.codMarca === this.codMarca)
        && (arg.maxFaixaPreco === this.maxFaixaPreco)
        && (arg.exibeItemZerado === this.exibeItemZerado)
        && (arg.codEmpresaLogin === this.codEmpresaLogin)
    ;
  }
}


export class DataFreteVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteVitrinePubAPP";
  frete: ArrayList<DataFreteAPP> = new ArrayList<DataFreteAPP>(DataFreteAPP);
  codClienteMacle: number = 0;
  nomeLoja: string = "";
}


export class FiltroNodeItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeItemAPP";
  codigo: number = 0;
  descricao: string = "";
  quantidade: number = 0;
}


export class DataResultEmitePixZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmitePixZoopAPP";
  qr_code: string = "";
  dataHoraValidade: string = "";
  valorPIX: number = 0;
  qr_code_url: string = "";
  pkLiquidacao: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
}


export class DataPedidoEntregaVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVit";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  retiradaLoja: boolean = false;
  taxaEntrega: number = 0;
}


export class DataFrenetShippingServiceResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingServiceResponseVit";
  error: boolean = false;
  carrier: string = "";
  msg: string = "";
  shippingPrice: number = 0;
  deliveryTime: number = 0;
  serviceCode: string = "";
  carrierCode: string = "";
  originalDeliveryTime: number = 0;
  serviceDescription: string = "";
  originalShippingPrice: number = 0;
}


export class DataFrenetShippingResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingResponseVit";
  shippingSevicesArray: ArrayList<DataFrenetShippingServiceResponseVit> = new ArrayList<DataFrenetShippingServiceResponseVit>(DataFrenetShippingServiceResponseVit);
}


export class DataNovoClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataNovoClienteAPP";
  email: string = "";
  nome: string = "";
  numero: string = "";
  cidade: string = "";
  bairro: string = "";
  cep: string = "";
  cpf: string = "";
  uf: string = "";
  complemento: string = "";
  nascimento: string = "";
  endereco: string = "";
  telefone: string = "";
}


export class DataVendaItemAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaItemAPP";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  qtd: number = 0;
  descricao: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
}


export class DataEmiteBoletoVendaPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoVendaPagarMeAPP";
  email: string = "";
  nome: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
  enderecoBairro: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  enderecoNumero: string = "";
  numeroDocumento: string = "";
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  endereco: string = "";
  telefone: string = "";
  dadosResumidos: boolean = false;
}


export class DataFreteVitrineServico extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineServico";
  nome: string = "";
  codigo: string = "";
  indisponivel: boolean = false;
  valorEntrega: number = 0;
  diasEntrega: number = 0;
}


export enum EOrdenacaoItem {
  NONE = 0,
  MAIS_RELEVANTE = 1,
  MENORES_PRECOS = 2,
  MAIORES_PRECOS = 3,
  MAIORES_DESCONTOS = 4,
}

export namespace EOrdenacaoItem {
  export function toDisplay(arg: EOrdenacaoItem): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Mais relevantes";
      case 2: return "Menores precos";
      case 3: return "Maiores precos";
      case 4: return "Maiores descontos";
      default: return "";
    }
  }

  export function enums(): EOrdenacaoItem[] {
    return [EOrdenacaoItem.NONE,EOrdenacaoItem.MAIS_RELEVANTE,EOrdenacaoItem.MENORES_PRECOS,EOrdenacaoItem.MAIORES_PRECOS,EOrdenacaoItem.MAIORES_DESCONTOS];
  }
}


export class FilterItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterItemVit";
  ativo: EFilterBool = EFilterBool.NONE;
  genero: EGenero = EGenero.NONE;
  codTamanho: number = 0;
  descricao: string = "";
  ordenacao: EOrdenacaoItem = EOrdenacaoItem.NONE;
  gtin: number = 0;
  ltipos: number[] = [];
  lmarcas: number[] = [];
  precoMin: number = 0;
  classeSite: EClasseItemSite = EClasseItemSite.NONE;
  precoMax: number = 0;
  faixaEtaria: EFaixaEtaria = EFaixaEtaria.NONE;
  itemControle: PKItemControleVit = new PKItemControleVit();
  hashtags: number[] = [];
}


export class PKPagarMeTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagarMeTransacaoAPP";
  codPagarMeTransacao: number = 0;

  constructor()
  constructor(codPagarMeTransacao: number)
  constructor(codPagarMeTransacao?: number) {
    super();
    this.codPagarMeTransacao = codPagarMeTransacao || 0;
  }

  public getPK(): PKPagarMeTransacaoAPP {
    return new PKPagarMeTransacaoAPP(this.codPagarMeTransacao);
  }

  public equals(arg: PKPagarMeTransacaoAPP): boolean {
    return arg 
        && (arg.codPagarMeTransacao === this.codPagarMeTransacao)
    ;
  }
}


export class DataParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataParametrosAPP";
  habilitaComprasAPP: boolean = false;
  taxaBoletoAbaixoDeAPP: number = 0;
  servidorConsulta: string = "";
  qtdMaxParcelaAPP: number = 0;
  habilitaBoletoCompraAPP: boolean = false;
  habilitaCartaoCompraAPP: boolean = false;
  valorMinParcelaAPP: number = 0;
  pctDescontoBoletoAPP: number = 0;
  habilitaEntregaCompraAPP: boolean = false;
  habilitaBoletoParcelaAPP: boolean = false;
  habilitaPIXCompraAPP: boolean = false;
  habilitaCondicionalAPP: boolean = false;
  pctDescontoCompraPIXAPP: number = 0;
  cepOrigemSigepAPP: number = 0;
  habilitaPIXParcelaAPP: boolean = false;
  appVitrinePublica: boolean = false;
  codContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  ativo: boolean = false;
  CNPJ: string = "";
  macleID: string = "";
  lconta: ArrayList<DataContaAPP> = new ArrayList<DataContaAPP>(DataContaAPP);
  urlAPP: string = "";
  idSellerZoop: string = "";
  tokenFrenet: string = "";
  chaveAPIPagarMe: string = "";
  dataReferencia: string = "";
  fantasia: string = "";
  whatsApp: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  logoBase64: string = "";
  telefone: string = "";
  codEmpresaContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  diasValidadeLinkVendedorAPP: number = 0;
  tipoFreteGratisCorreioAPP: ETipoFrete = ETipoFrete.NONE;
  habilitaConsultaEstoqueVendedor: boolean = false;
  habilitaLiquidacaoParcelaAPP: boolean = false;
  qtdMaxParcelaCrediarioAPP: number = 0;
  pctDescontoCreditoCartaoAPP: number = 0;
  valorTaxaEntregaCondicionalAPP: number = 0;
  habilitaEntregaCorreiosAPP: boolean = false;
  chaveCriptografiaPagarMe: string = "";
  habilitaRetiradaLojaCompraAPP: boolean = false;
  habilitaCrediarioCompraAPP: boolean = false;
  empresaRetirataMercadoriaAPP: string = "";
  valorMinParcelaCrediarioAPP: number = 0;
  valorFreteGratisCorreioAPP: number = 0;
  habilitaVisMensagemCompraWhatsAPP: boolean = false;
  taxaBoletoLiquidacaoParcelaAplicativo: number = 0;
  distanciaMaximaEntregaCondicionalAPP: number = 0;
  valorTaxaEntregaCompraAbaixoDeAPP: number = 0;
  habilitaSomenteConsultaParcelaAPP: boolean = false;
}


export class DataSendDadosEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendDadosEmissaoBoletoAPP";
  versaoEmissaoAPP: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  dadosEmissaoAPP: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class DataFreteVitrineOperadora extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineOperadora";
  nome: string = "";
  codigo: string = "";
  servicos: ArrayList<DataFreteVitrineServico> = new ArrayList<DataFreteVitrineServico>(DataFreteVitrineServico);
}


export enum ETipoPrecoVendaAPP {
  NONE = 0,
  PRCITEM = 1,
  PRCEMPRESA = 2,
  PRCTAMANHO = 3,
  PRCEMPTAM = 4,
}

export namespace ETipoPrecoVendaAPP {
  export function toDisplay(arg: ETipoPrecoVendaAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pre&ccedil;o do item";
      case 2: return "Pre&ccedil;o por empresa";
      case 3: return "Pre&ccedil;o por tamanho";
      case 4: return "Prc.empresa e tamanho";
      default: return "";
    }
  }

  export function enums(): ETipoPrecoVendaAPP[] {
    return [ETipoPrecoVendaAPP.NONE,ETipoPrecoVendaAPP.PRCITEM,ETipoPrecoVendaAPP.PRCEMPRESA,ETipoPrecoVendaAPP.PRCTAMANHO,ETipoPrecoVendaAPP.PRCEMPTAM];
  }
}


export class DataRetirarLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRetirarLojaVitrinePubAPP";
  fantasia: string = "";
  codClienteMacle: number = 0;
  lojasComVendedor: ConsLojasComVendedorAPP = new ConsLojasComVendedorAPP();
}


export class ConsCorItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCorItemAPP";
  nome: string = "";
  imagem: string = "";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, nome: string, imagem: string)
  constructor(codEmpItem?: number, codItem?: number, nome?: string, imagem?: string) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.nome = nome || "";
    this.imagem = imagem || "";
  }

  public getPK(): ConsCorItemAPP {
    return new ConsCorItemAPP(this.codEmpItem, this.codItem, this.nome, this.imagem);
  }

  public equals(arg: ConsCorItemAPP): boolean {
    return arg 
        && (arg.nome === this.nome)
        && (arg.imagem === this.imagem)
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export enum EStatusProdutoML {
  NONE = 0,
  active = 1,
  closed = 2,
  paused = 3,
  under_review = 4,
}

export namespace EStatusProdutoML {
  export function toDisplay(arg: EStatusProdutoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Ativo";
      case 2: return "Inativo";
      case 3: return "Pausado";
      case 4: return "Em revis&atilde;o";
      default: return "";
    }
  }

  export function enums(): EStatusProdutoML[] {
    return [EStatusProdutoML.NONE,EStatusProdutoML.active,EStatusProdutoML.closed,EStatusProdutoML.paused,EStatusProdutoML.under_review];
  }
}


export class ConsTamanhoItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsTamanhoItemAPP";
  codTamanho: number = 0;
  disponivel: boolean = false;
  descricao: string = "";

  constructor()
  constructor(codTamanho: number, descricao: string, disponivel: boolean)
  constructor(codTamanho?: number, descricao?: string, disponivel?: boolean) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.disponivel = disponivel || false;
  }

  public getPK(): ConsTamanhoItemAPP {
    return new ConsTamanhoItemAPP(this.codTamanho, this.descricao, this.disponivel);
  }

  public equals(arg: ConsTamanhoItemAPP): boolean {
    return arg 
        && (arg.codTamanho === this.codTamanho)
        && (arg.disponivel === this.disponivel)
        && (arg.descricao === this.descricao)
    ;
  }
}


export class DataVendaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaAPP";
  data: string = "";
  cliente: DataVendaClienteAPP = new DataVendaClienteAPP();
  hora: string = "";
  valor: number = 0;
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  enviadoSistema: boolean = false;
  formaPagamento: DataVendaFormaPagamentoAPP = new DataVendaFormaPagamentoAPP();
  idPedidoEntregaML: number = 0;
  codEmpresaVenda: number = 0;
  vendaFinalizada: boolean = false;
  listEntrega: ArrayList<DataVendaEntregaAPP> = new ArrayList<DataVendaEntregaAPP>(DataVendaEntregaAPP);
  idPedidoML: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataVendaEnderecoAPP = new DataVendaEnderecoAPP();
  enviadoVitrine: boolean = false;
  pkVendaVit: PKVendaVit = new PKVendaVit();
  cupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
  listItem: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  desconto: number = 0;
  codVitrineVenda: number = 0;
}


export class PKPagamentoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoParcelaAPP";
  id: number = 0;
  idPagarmeV5: string = "";

  constructor()
  constructor(codLiquidacaoParcela: number, id: number, idPagarmeV5: string)
  constructor(codLiquidacaoParcela?: number, id?: number, idPagarmeV5?: string) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
    this.id = id || 0;
    this.idPagarmeV5 = idPagarmeV5 || "";
  }

  public getPK(): PKPagamentoParcelaAPP {
    return new PKPagamentoParcelaAPP(this.codLiquidacaoParcela, this.id, this.idPagarmeV5);
  }

  public equals(arg: PKPagamentoParcelaAPP): boolean {
    return arg && super.equals(arg)
        && (arg.id === this.id)
        && (arg.idPagarmeV5 === this.idPagarmeV5)
    ;
  }
}


export enum EVersaoProdutoML {
  NONE = 0,
  V1 = 1,
  V2 = 2,
}

export namespace EVersaoProdutoML {
  export function toDisplay(arg: EVersaoProdutoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Vers&atilde;o Antiga";
      case 2: return "Vers&atilde;o Nova (User Products)";
      default: return "";
    }
  }

  export function enums(): EVersaoProdutoML[] {
    return [EVersaoProdutoML.NONE,EVersaoProdutoML.V1,EVersaoProdutoML.V2];
  }
}


export class FiltroNodeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeAPP";
  value: number = 0;
  nome: string = "";
  visivel: boolean = false;
  display: string = "";
  lista: ArrayList<FiltroNodeItemAPP> = new ArrayList<FiltroNodeItemAPP>(FiltroNodeItemAPP);
}


export class ConsumidorSiteResponseChaveConfirmacaoValida extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseChaveConfirmacaoValida";
  chaveConfirmacaoValida: boolean = false;
  token: string = "";
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
}


export class DataPrecoVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataPrecoVendaAPP";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  promocao: boolean = false;
  dataIniPromo: string = "";
  precoVenda: number = 0;
  vlrPromo: number = 0;
  congelado: boolean = false;
  dataAlter: string = "";
  dataFimPromo: string = "";
  precoAlter: number = 0;
  codEmpresa: number = 0;
}


export class ConsItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsItemAPP";
  tipo: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  promocao: boolean = false;
  marca: string = "";
  preco: number = 0;
  imagens: string[] = [];
  cores: ArrayList<ConsCorItemAPP> = new ArrayList<ConsCorItemAPP>(ConsCorItemAPP);
  precos: ArrayList<DataPrecoVendaAPP> = new ArrayList<DataPrecoVendaAPP>(DataPrecoVendaAPP);
  tamanhos: ArrayList<ConsTamanhoItemAPP> = new ArrayList<ConsTamanhoItemAPP>(ConsTamanhoItemAPP);
  tipoPreco: ETipoPrecoVendaAPP = ETipoPrecoVendaAPP.NONE;
  refFornecedor: string = "";
  precoTabela: number = 0;
  descricao: string = "";
}


export class DataPedidoItemVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVit";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  itemVit: PKTamanhoItemVit = new PKTamanhoItemVit();
  qtd: number = 0;
  descricao: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
  codCupomDesconto: number = 0;
}


export class ConsClienteAPP extends PKDependenteAPP {
  readonly jclass: string = "com.macle.app.vo.ConsClienteAPP";
  cnpj: string = "";
  pontos: number = 0;
  email: string = "";
  nome: string = "";
  sexo: ESexo = ESexo.NONE;
  crediarioLiberado: boolean = false;
  totalLimiteCredito: number = 0;
  qtdParcVencida: number = 0;
  limiteCredito: number = 0;
  endereco: DataEndereco = new DataEndereco();
  clienteNovo: boolean = false;
  telefone: string = "";
  regraMinimaAtiva: boolean = false;
  dataNascimento: string = "";
  dadosResumidos: boolean = false;
  qtdItens: number = 0;
  qtdParcAtivas: number = 0;
}


export enum EStatusPedidoPagamentoML {
  none = 0,
  rejected = 1,
  approved = 2,
  cancelled = 3,
  refunded = 4,
  in_mediation = 5,
  charged_back = 6,
}

export namespace EStatusPedidoPagamentoML {
  export function toDisplay(arg: EStatusPedidoPagamentoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagamento rejeitado";
      case 2: return "Pagamento aprovado";
      case 3: return "Pagamento cancelado";
      case 4: return "Pagamento devolvido";
      case 5: return "Pagamento em media&ccedil;&atilde;o";
      case 6: return "Pagamento em chargeback";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoPagamentoML[] {
    return [EStatusPedidoPagamentoML.none,EStatusPedidoPagamentoML.rejected,EStatusPedidoPagamentoML.approved,EStatusPedidoPagamentoML.cancelled,EStatusPedidoPagamentoML.refunded,EStatusPedidoPagamentoML.in_mediation,EStatusPedidoPagamentoML.charged_back];
  }
}


export class DataEmiteBoletoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoPagarMeAPP";
  email: string = "";
  nome: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
  enderecoBairro: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  liquidacao: DataLiquidacaoParcelaAPP = new DataLiquidacaoParcelaAPP();
  enderecoNumero: string = "";
  numeroDocumento: string = "";
  endereco: string = "";
  telefone: string = "";
  dadosResumidos: boolean = false;
}


export class DataRespCanSelect extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRespCanSelect";
  canSelect: boolean = false;
  canSelectText: string = "";
}


export class DataEmiteCartaoDeCreditoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteCartaoDeCreditoPagarMeAPP";
  email: string = "";
  nome: string = "";
  mesValidadeCartao: number = 0;
  anoValidadeCartao: number = 0;
  enderecoComplemento: string = "";
  codigoSegurancaCartao: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  valor: number = 0;
  enderecoBairro: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  enderecoNumero: string = "";
  numeroDocumento: string = "";
  cardHash: string = "";
  valorFrete: number = 0;
  nomeCartao: string = "";
  numeroCartao: string = "";
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  qtdParcela: number = 0;
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  endereco: string = "";
  telefone: string = "";
  dadosResumidos: boolean = false;
}


export class DataVendaItemVitPub extends PKItemLojaVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVitPub";
  descricaoTamanho: string = "";
  qtd: number = 0;
  codTamanho: number = 0;
  imgPequenoBase64: string = "";
  descricao: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  itemControle: PKItemControleVit = new PKItemControleVit();
}


export class DataVendaVitPub extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVitPub";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  codEmpresaVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  listItem: ArrayList<DataVendaItemVitPub> = new ArrayList<DataVendaItemVitPub>(DataVendaItemVitPub);
  desconto: number = 0;
  codVitrineVenda: number = 0;
}


export class DataFreteVitrine extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrine";
  codigo: string = "";
  operadoras: ArrayList<DataFreteVitrineOperadora> = new ArrayList<DataFreteVitrineOperadora>(DataFreteVitrineOperadora);
}


export class DataMedidaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMedidaItemVit";
  comprimentoCM: number = 0;
  alturaCM: number = 0;
  larguraCM: number = 0;
  pesoGramas: number = 0;
}


export class DataPagamentoParcelaAPP extends PKPagamentoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoParcelaAPP";
  valor: number = 0;
  dataPagamento: string = "";
  dataCriacao: string = "";
}


export class DataPedidoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVit";
  data: string = "";
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  hora: string = "";
  valor: number = 0;
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  enviadoSistema: boolean = false;
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  idPedidoML: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  cupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
  listItem: ArrayList<DataPedidoItemVit> = new ArrayList<DataPedidoItemVit>(DataPedidoItemVit);
  desconto: number = 0;
  entrega: DataPedidoEntregaVit = new DataPedidoEntregaVit();
  antiFraude: DataPedidoAntFraudeVit = new DataPedidoAntFraudeVit();
  acrescimo: number = 0;
  pedidoML: DataPedidoResultML = new DataPedidoResultML();
  horaUltimoUpdate: string = "";
  codEmpresaPedido: number = 0;
  dataUltimoUpdate: string = "";
  nroetiquetasigep: string = "";
  salvarEnderecoFuturo: boolean = false;
  dataCancelamento: string = "";
}


export class DataTipoItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataTipoItemVit";
  descricaoTipo: string = "";
  codigoTipo: number = 0;
}


export class DataFrenetPedidoEtiquetaResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaResponseVit";
  items: ArrayList<DataFrenetPedidoEtiquetaItemResponseVit> = new ArrayList<DataFrenetPedidoEtiquetaItemResponseVit>(DataFrenetPedidoEtiquetaItemResponseVit);
  error: DataFrenetPedidoEtiquetaErroVit = new DataFrenetPedidoEtiquetaErroVit();
  statusBatch: string = "";
}


export class DataMarcaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMarcaItemVit";
  codigoMarca: number = 0;
  descricaoMarca: string = "";
}


export class FilterPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterPedidoVit";
  cnpj: string = "";
  dataIni: string = "";
  dataFim: string = "";
  enviadoSistema: EFilterBool = EFilterBool.NONE;
}


